const NS = 'TableBlock';
const CLS = 'tableBlock';

let agGrid = require('ag-grid-community');

import { numberFormatter } from '../../../../global/js/wool/numberFormatter';
import { operatingSystemDetector } from '../../../../global/js/wool/operatingSystemDetector';

export class TableBlock {
	constructor(element, className = CLS) {
		this.element = element;
		this.$element = $(element);
		this.$agThemeWool = this.$element.children('.ag-theme-wool');
		this.numberFormatter = numberFormatter;
		this.operatingSystemDetector = operatingSystemDetector;
		this.operatingSystem = this.operatingSystemDetector.getOS();

		this.setEmptyMessages();
		this.scrollbarWidth = 8;
		this.columnDefs = [];
		this.rowData = [];
		this.noRowsTypes = {
			error: 'error',
			empty: 'empty'
		};
		this.noRowsType = this.noRowsTypes.empty;

		if(this.operatingSystem === this.operatingSystemDetector.OperatingSystemItems.Windows) {
			this.$agThemeWool.addClass('ag-theme-windows');
			this.scrollbarWidth = 17;
		}

		this.setCustomLoadingOverlay();
		this.setCustomNoRowsOverlay();
		this.setTableData();
		this.setGridOptions();
		this.loadGrid();
		this.gridOptions.api.showLoadingOverlay();

		this.$element.on(`${className}.update`, (event, params) => {
			if(params.data && params.data.length > 0) {
				this.gridOptions.api.hideOverlay();
				this.$element.find('.ag-root').removeClass('ag-root--error');
			}
			else {
				if(params.isEmpty) {
					this.noRowsType = this.noRowsTypes.empty;
					this.$element.find('.ag-root').removeClass('ag-root--error');
				}
				else {
					this.noRowsType = this.noRowsTypes.error;
					this.$element.find('.ag-root').addClass('ag-root--error');
				}
				this.gridOptions.api.showNoRowsOverlay();
			}
			this.updateRowData(params.data);
		});
	}

	// Sets the generic error messages
	setEmptyMessages() {
		this.emptyMessage = !_.isNil(this.$element.attr('data-empty-message')) ? this.$element.attr('data-empty-message') : 'No items loaded';
		this.errorMessage = !_.isNil(this.$element.attr('data-error-message')) ? this.$element.attr('data-error-message') : 'Error in loading table…';
	}

	setCustomLoadingOverlay() {
		this.CustomLoadingOverlay = () => {};
		this.CustomLoadingOverlay.prototype.init = () => {
			this.eGui = document.createElement('div');
			this.eGui.innerHTML = `<div class="ag-overlay-loading-center">
				<div class="loaderWidget" data-wg="LoaderWidget"></div>
			</div>`;
		};

		this.CustomLoadingOverlay.prototype.getGui = () => {
			return this.eGui;
		};
	}

	setCustomNoRowsOverlay() {
		this.CustomNoRowsOverlay = () => {};
		this.CustomNoRowsOverlay.prototype.init = () => {
			let message = this.emptyMessage;
			let errorClass = this.noRowsType === this.noRowsTypes.error ? 'ag-overlay-loading-center-message--error' : '';
			if(this.noRowsType === this.noRowsTypes.error) {
				message = this.errorMessage;
			}

			this.eGui = document.createElement('div');
			this.eGui.innerHTML = `<div class="ag-overlay-loading-center">
				<div class="ag-overlay-loading-center-message ${errorClass}">
					${message}
				</div>
			</div>`;
		};

		this.CustomNoRowsOverlay.prototype.getGui = () => {
			return this.eGui;
		};
	}

	setTableData() {
	}

	setGridOptions(gridOptions = {}) {
		this.gridOptions = {
			columnDefs: this.columnDefs,
			rowData: this.rowData,
			domLayout: 'autoHeight',
			scrollbarWidth: this.scrollbarWidth,
			onGridReady: (_event) => {
				this.resizeTable();

				$(window).on('resize', _.throttle(() => {
					this.resizeTable();
				}, 250));
			},
			suppressDragLeaveHidesColumns: true,
			context: {
				numberFormatter: this.numberFormatter
			},
			components: {
				customLoadingOverlay: this.CustomLoadingOverlay,
				customNoRowsOverlay: this.CustomNoRowsOverlay
			},
			loadingOverlayComponent: 'customLoadingOverlay',
			noRowsOverlayComponent: 'customNoRowsOverlay'
		};

		this.gridOptions = _.extend(this.gridOptions, gridOptions);
	}

	loadGrid() {
		this.eGridDiv = this.$agThemeWool[0];
		this.agGrid = new agGrid.Grid(this.eGridDiv, this.gridOptions);
	}

	updateRowData(items) {
		this.gridOptions.api.updateRowData({
			add: items
		});
	}

	resizeTable() {
		this.resizeRows();
		this.resizeColumns();
	}

	resizeRows() {
	}

	resizeColumns() {
		// Retrieve column values
		let columns = this.gridOptions.columnApi.getAllColumns();

		let columnIds = _.map(columns, (column) => {
			return column.getColId();
		});

		// Autosize the columns
		this.gridOptions.columnApi.autoSizeColumns(columnIds);

		// Retrieve the totalWidth of the autosized columns
		let totalAutosizedWidth = _.sumBy(columns, (column) => {
			return column.getActualWidth();
		});

		// Retreive the totalWidth of the agGrid
		let gridWidth = this.$element.outerWidth();

		// Fit the columns when the autosized columns is less than the acutal grid
		if(totalAutosizedWidth < gridWidth) {
			this.gridOptions.api.sizeColumnsToFit();
		}
		else {
			this.gridOptions.columnApi.autoSizeColumns(columnIds);
		}
	}
}
